import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import classnames from 'classnames';
import Context from '../../context';
import { getQuarter, getStartOfQuarter, getYear, isAfter, isBefore, isSameQuarter, newDate, setQuarter } from '../../utils/date-fns';
import useRangeCls from '../../hooks/use-range-cls';
var quarterList = ['Q1', 'Q2', 'Q3', 'Q4'];

function Quarter(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls,
      dateValue = context.dateValue,
      viewDate = context.viewDate,
      onSelect = context.onSelect,
      onDateMouseEnter = context.onDateMouseEnter,
      onDateMouseLeave = context.onDateMouseLeave,
      rangeValue = context.rangeValue,
      panelPosition = context.panelPosition,
      hoverRangedValue = context.hoverRangedValue;
  var disabledDate = props.disabledDate;

  var _dateValue;

  if (panelPosition) {
    _dateValue = rangeValue;
  } else {
    _dateValue = dateValue;
  }

  var hasFindSelected = false;
  var hasFindToday = false;

  var getQuarterSelected = function getQuarterSelected(quarter) {
    if (hasFindSelected) return false;

    if (Array.isArray(_dateValue)) {
      return _dateValue[0] && getQuarter(_dateValue[0]) === quarter && getYear(_dateValue[0]) === getYear(viewDate) || _dateValue[1] && getQuarter(_dateValue[1]) === quarter && getYear(_dateValue[1]) === getYear(viewDate);
    } else {
      if (_dateValue && getQuarter(_dateValue) === quarter && getYear(_dateValue) === getYear(viewDate)) {
        hasFindSelected = true;
        return true;
      }

      return false;
    }
  };

  var getQuarterToday = function getQuarterToday(quarter) {
    if (hasFindToday) return false;

    if (getYear(viewDate) === getYear(newDate()) && quarter === getQuarter(newDate())) {
      hasFindToday = true;

      if (Array.isArray(_dateValue)) {
        return _dateValue[0] ? getQuarter(_dateValue[0]) !== quarter : _dateValue[1] ? getQuarter(_dateValue[1]) !== quarter : true;
      } else {
        return _dateValue ? getQuarter(_dateValue) !== quarter : true;
      }
    }
  };

  var getQuarterClassNames = function getQuarterClassNames(q) {
    var _classnames;

    return classnames("".concat(prefixCls, "-quarter-text"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-quarter-text-selected"), getQuarterSelected(q)), _defineProperty(_classnames, "".concat(prefixCls, "-quarter-text-today"), getQuarterToday(q)), _classnames));
  };

  var getRangeCls = useRangeCls({
    prefixCls: prefixCls,
    rangeValue: rangeValue,
    hoverRangedValue: hoverRangedValue,
    isRange: !!panelPosition,
    isAfterStart: function isAfterStart(date, rangedValue) {
      return rangedValue[0] ? isAfter(getStartOfQuarter(date), getStartOfQuarter(rangedValue[0])) : false;
    },
    isBeforeEnd: function isBeforeEnd(date, rangedValue) {
      return rangedValue[1] ? isBefore(getStartOfQuarter(date), getStartOfQuarter(rangedValue[1])) : false;
    },
    isStart: function isStart(date, rangedValue) {
      return rangedValue[0] ? isSameQuarter(date, rangedValue[0]) : false;
    },
    isEnd: function isEnd(date, rangedValue) {
      return rangedValue[1] ? isSameQuarter(date, rangedValue[1]) : false;
    }
  });

  var handleClick = function handleClick(date) {
    if (!(disabledDate && disabledDate(date))) {
      onSelect(date, 'mouse');
    }
  };

  var renderQuarter = function renderQuarter() {
    return _mapInstanceProperty(quarterList).call(quarterList, function (n, i) {
      var quarter = setQuarter(viewDate, i + 1);
      var _props = {
        onClick: function onClick() {
          return handleClick(quarter);
        },
        onMouseEnter: function onMouseEnter() {
          if (onDateMouseEnter && !(disabledDate && disabledDate(quarter))) {
            onDateMouseEnter(quarter);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (onDateMouseLeave) {
            onDateMouseLeave();
          }
        }
      };
      var quarterCls = classnames("".concat(prefixCls, "-quarter-item"), _defineProperty({}, "".concat(prefixCls, "-quarter-item-disabled"), disabledDate && disabledDate(quarter)), getRangeCls(quarter));
      return /*#__PURE__*/React.createElement("div", {
        key: n,
        className: quarterCls
      }, /*#__PURE__*/React.createElement("div", _extends({
        className: getQuarterClassNames(i + 1)
      }, _props), n));
    });
  };

  var quarterCls = classnames("".concat(prefixCls, "-quarter"));
  var quarterWarpperCls = classnames("".concat(prefixCls, "-quarter-warpper"));
  return /*#__PURE__*/React.createElement("div", {
    className: quarterCls
  }, /*#__PURE__*/React.createElement("div", {
    className: quarterWarpperCls
  }, renderQuarter()));
}

export default Quarter;